import { useState, useEffect, useCallback } from 'react';

const PHOTOS = [
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/0f0625efcb2fc8db679521c3d7688c1f.jpeg',
    alt: 'Кованые ворота распашные — готовый объект',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/78603ec7fe11d472a015d61cc1704daa.jpeg',
    alt: 'Ворота откатные с забором и калиткой — готовый объект',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/a13b804b105f3bb7623d22dd28c2c09d.jpeg',
    alt: 'Садовые качели с навесом — готовый объект',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/1fa85310b2c8baf26f5b6e39dd05ab61.jpeg',
    alt: 'Беседка-арка с лавками — готовый объект',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/3f4d59f78448aa62bd07218021eabc27.jpeg',
    alt: 'Кованая кровать — готовый объект',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/89ad10a9-5906-4795-845c-1e4763f3e834_compressed_photo_2026-07-27-18.06.51.webp',
    alt: 'Навес кованый открытый — готовый объект',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/64c9a9d2-a22b-40c5-98f6-9596897a5616_compressed_photo_2026-07-27-18.07.04.webp',
    alt: 'Навес-карпорт с коваными элементами — готовый объект',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/da58a426-0767-41de-913c-c8ddf990ecc1_compressed_photo_2026-07-27-18.07.25.webp',
    alt: 'Кованый козырёк над входом — готовый объект',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/fb1db131-59be-4f54-be3e-68e0db788426_compressed_photo_2026-07-27-18.07.47.webp',
    alt: 'Навес пристроенный к дому — готовый объект',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/f1b6255b-85cb-43e7-bc31-194f8bfe6b79_compressed_photo_2026-07-27-18.07.41.webp',
    alt: 'Кованый навес над въездом — готовый объект',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/fb1db131-59be-4f54-be3e-68e0db788426_compressed_photo_2026-07-27-18.07.47.webp',
    alt: 'Навес пристроенный к дому с металлоконструкцией — готовый объект',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/e124cf9c-f510-4803-b614-b627c0084d59_compressed_photo_2026-07-27-18.07.50.webp',
    alt: 'Большой арочный карпорт с поликарбонатом — готовый объект',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/86f556d8-ffd0-4b67-93be-e3ac5afe2052_compressed_photo_2026-07-27-18.07.59.webp',
    alt: 'Кованые ворота с навесом и красным поликарбонатом — готовый объект',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/8f30f5ab-b237-4c6c-ba7f-83f851b11a2d_compressed_photo_2026-07-27-18.08.04.webp',
    alt: 'Ворота откатные кованые с красным поликарбонатом — готовый объект',
  },
];

export default function Gallery() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const open = (idx: number) => setLightboxIndex(idx);
  const close = () => setLightboxIndex(null);

  const goPrev = useCallback(() => {
    setLightboxIndex((prev) => (prev !== null ? (prev - 1 + PHOTOS.length) % PHOTOS.length : null));
  }, []);

  const goNext = useCallback(() => {
    setLightboxIndex((prev) => (prev !== null ? (prev + 1) % PHOTOS.length : null));
  }, []);

  useEffect(() => {
    if (lightboxIndex === null) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') goPrev();
      if (e.key === 'ArrowRight') goNext();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [lightboxIndex, goPrev, goNext]);

  const currentPhoto = lightboxIndex !== null ? PHOTOS[lightboxIndex] : null;

  return (
    <>
      <section className="py-16 md:py-20 bg-background-100" id="gallery">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Примеры наших работ
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Реальные объекты, которые мы уже построили для&nbsp;наших клиентов
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-3">
            {PHOTOS.map((photo, idx) => (
              <div
                key={idx}
                role="button"
                tabIndex={0}
                onClick={() => open(idx)}
                onKeyDown={(e) => { if (e.key === 'Enter') open(idx); }}
                className="relative group rounded-md overflow-hidden bg-background-200 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
              >
                <div className="w-full h-40 md:h-44">
                  <img
                    src={photo.src}
                    alt={photo.alt}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-400 flex items-end">
                  <p className="text-background-50 text-xs font-medium px-2 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-400 w-full bg-gradient-to-t from-black/70 to-transparent leading-tight">
                    {photo.alt}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {currentPhoto && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm animate-fade-in"
          onClick={close}
        >
          {/* Close button */}
          <button
            onClick={close}
            className="whitespace-nowrap absolute top-5 right-5 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
            aria-label="Закрыть"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>

          {/* Prev */}
          <button
            onClick={(e) => { e.stopPropagation(); goPrev(); }}
            className="whitespace-nowrap absolute left-3 md:left-6 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
            aria-label="Предыдущее"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          {/* Next */}
          <button
            onClick={(e) => { e.stopPropagation(); goNext(); }}
            className="whitespace-nowrap absolute right-3 md:right-6 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
            aria-label="Следующее"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          {/* Image */}
          <div
            className="max-w-[90vw] max-h-[85vh] flex flex-col items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={currentPhoto.src}
              alt={currentPhoto.alt}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
            <p className="text-background-50/80 text-sm text-center mt-4 max-w-lg">
              {currentPhoto.alt}
            </p>
            <p className="text-background-50/40 text-xs mt-1">
              {lightboxIndex! + 1} / {PHOTOS.length}
            </p>
          </div>
        </div>
      )}
    </>
  );
}